import { render, staticRenderFns } from "./FilterColumn.vue?vue&type=template&id=1680222e&scoped=true"
import script from "./FilterColumn.vue?vue&type=script&lang=ts"
export * from "./FilterColumn.vue?vue&type=script&lang=ts"
import style0 from "./FilterColumn.vue?vue&type=style&index=0&id=1680222e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1680222e",
  null
  
)

export default component.exports